// type Types = {
//   REALTIME_MATERIAL_PRICING_REQUEST: 'quotes/quoteitems/materialpricing/REALTIME_MATERIAL_PRICING_REQUEST',
//   REALTIME_MATERIAL_PRICING_SUCCESS: 'quotes/quoteitems/materialpricing/REALTIME_MATERIAL_PRICING_SUCCESS',
//   REALTIME_MATERIAL_PRICING_ERROR: 'quotes/quoteitems/materialpricing/REALTIME_MATERIAL_PRICING_ERROR',
// };

export const types = {
  REALTIME_MATERIAL_PRICING_REQUEST:
    'quotes/quoteitems/materialpricing/REALTIME_MATERIAL_PRICING_REQUEST',
  REALTIME_MATERIAL_PRICING_SUCCESS:
    'quotes/quoteitems/materialpricing/REALTIME_MATERIAL_PRICING_SUCCESS',
  REALTIME_MATERIAL_PRICING_ERROR:
    'quotes/quoteitems/materialpricing/REALTIME_MATERIAL_PRICING_ERROR',
};

// export type RealTimeMaterialPricingRequestAction = {
//   type: typeof types.REALTIME_MATERIAL_PRICING_REQUEST,
//   payload: { componentId: Id },
// };
// export type RealTimeMaterialPricingSuccessAction = {
//   type: typeof types.REALTIME_MATERIAL_PRICING_SUCCESS,
//   payload: Object,
// };
// export type RealTimeMaterialPricingErrorAction = {
//   type: typeof types.REALTIME_MATERIAL_PRICING_ERROR,
//   payload: Object,
// };
export const realTimeMaterialPricing = {
  request: (componentId, isRound) => ({
    type: types.REALTIME_MATERIAL_PRICING_REQUEST,
    payload: { componentId, isRound },
  }),
  success: (payload) => ({
    type: types.REALTIME_MATERIAL_PRICING_SUCCESS,
    payload: { ...payload },
  }),
  error: (error) => ({
    type: types.REALTIME_MATERIAL_PRICING_ERROR,
    payload: error,
  }),
};
